import { lazy } from "react";

// project import
import Loadable from "components/Loadable";
import DashboardLayout from "layout/Dashboard";
import PagesLayout from "layout/Pages";
import SimpleLayout from "layout/Simple";
import { SimpleLayoutType } from "config";
        

//-------------------------------------
// Template pages routing
const AuthLogin = Loadable(lazy(() => import("pages/auth/login")));
const AuthRegister = Loadable(lazy(() => import("pages/auth/register")));
const AuthForgotPassword = Loadable(lazy(() => import("pages/auth/forgot-password")));
const AuthResetPassword = Loadable(lazy(() => import("pages/auth/reset-password")));
const AuthResetPasswordResponse = Loadable(lazy(() => import("pages/auth/reset-password-confirmation")));
const AuthCheckMail = Loadable(lazy(() => import("pages/auth/check-mail")));
const AuthCodeVerification = Loadable(lazy(() => import("pages/auth/code-verification")));

const MaintenanceError = Loadable(lazy(() => import("pages/maintenance/404")));
const MaintenanceError500 = Loadable(lazy(() => import("pages/maintenance/500")));
const MaintenanceUnderConstruction = Loadable(lazy(() => import("pages/maintenance/under-construction")));
const MaintenanceComingSoon = Loadable(lazy(() => import("pages/maintenance/coming-soon")));

const SystemLocked = Loadable(lazy(() => import("pages/system-locked")));

//-------------------------------------
// pages routing

const DashboardRouter = Loadable(lazy(() => import("pages/content/dashboards/router")));
const DashboardDireccion = Loadable(lazy(() => import("pages/content/dashboards/direccion")));
const DashboardAdministrador = Loadable(lazy(() => import("pages/content/dashboards/administrador")));

// Clientes
const Clientes = Loadable(lazy(() => import("pages/content/clientes")));

// Órdenes de producción
const OrdenesProduccion = Loadable(lazy(() => import("pages/content/ordenes-produccion")));

// Área de producción
const AreaProduccion = Loadable(lazy(() => import("pages/content/area-produccion")));
const AreaProduccionKanbanProduccion = Loadable(lazy(() => import("pages/content/area-produccion/kanban-produccion")));

// Manufactura
const ManufacturaProductos = Loadable(lazy(() => import("pages/content/manufactura/productos")));
const ManufacturaInsumos = Loadable(lazy(() => import("pages/content/manufactura/insumos")));
const ManufacturaLotes = Loadable(lazy(() => import("pages/content/manufactura/lotes")));
const ManufacturaStock = Loadable(lazy(() => import("pages/content/manufactura/stock")));
const ManufacturaMovimientosDeStock = Loadable(lazy(() => import("pages/content/manufactura/movimientos-de-stock")));
const ManufacturaInsumosPorProducto = Loadable(lazy(() => import("pages/content/manufactura/insumos-por-producto")));
const ManufacturaInsumosPorOrdenDeProduccion = Loadable(lazy(() => import("pages/content/manufactura/insumos-por-orden-de-produccion")));

// Agenda
const Agenda = Loadable(lazy(() => import("pages/content/agenda")));

// Kanban board
const KanbanBoard = Loadable(lazy(() => import("pages/content/kanban-board")));

// Kanban individual
const KanbanIndividual = Loadable(lazy(() => import("pages/content/kanban-individual")));

// Finanzas
const FinanzasCxc = Loadable(lazy(() => import("pages/content/finanzas/cxc")));
const FinanzasCxcTablaMensual = Loadable(lazy(() => import("pages/content/finanzas/cxc/tabla-mensual")));
const FinanzasCxcHistorico = Loadable(lazy(() => import("pages/content/finanzas/cxc/historico")));
const FinanzasCobros = Loadable(lazy(() => import("pages/content/finanzas/cobros")));
const FinanzasCobrosCompleto = Loadable(lazy(() => import("pages/content/finanzas/cobros/completo")));
const FinanzasCobrosGeneradorDeComprobante = Loadable(lazy(() => import("pages/content/finanzas/cobros/generador-de-comprobante")));
const FinanzasCobrosHistorico = Loadable(lazy(() => import("pages/content/finanzas/cobros/historico")));
const FinanzasGastos = Loadable(lazy(() => import("pages/content/finanzas/gastos")));
const FinanzasGastosCompleto = Loadable(lazy(() => import("pages/content/finanzas/gastos/completo")));
const FinanzasGastosPorOrdenDeProduccion = Loadable(lazy(() => import("pages/content/finanzas/gastos/gastos-por-orden-de-produccion")));
const FinanzasGastosHistorico = Loadable(lazy(() => import("pages/content/finanzas/gastos/historico")));
const FinanzasEstadoDeResultados = Loadable(lazy(() => import("pages/content/finanzas/estado-de-resultados")));

// Catálogos
const CatalogosUsuarios = Loadable(lazy(() => import("pages/content/catalogos/usuarios")));
const CatalogosUnidades = Loadable(lazy(() => import("pages/content/catalogos/unidades")));
const CatalogosConceptosGastos = Loadable(lazy(() => import("pages/content/catalogos/conceptos-gastos")));
const CatalogosCuentasContables = Loadable(lazy(() => import("pages/content/catalogos/cuentas-contables")));
const CatalogosProveedores = Loadable(lazy(() => import("pages/content/catalogos/proveedores")));

// Diseñador de audífono
const DisenadorDeAudifono = Loadable(lazy(() => import("pages/content/disenador-de-audifono")));



// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: <DashboardLayout />,
      children: [
        {
          path: "home",
          children: [
            {
              path: "",
              element: <DashboardRouter />,
            },
          ],
        },
        {
          path: "dashboard",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <DashboardDireccion />,
            },
            {
              path: "direccion",
              element: <DashboardDireccion />,
            },
            {
              path: "administrador",
              element: <DashboardAdministrador />,
            },
          ],
        },
        {
          path: "clientes",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <Clientes />,
            },
          ],
        },
        {
          path: "ordenes-produccion",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <OrdenesProduccion />,
            },
          ],
        },
        {
          path: "area-produccion",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <AreaProduccion />,
            },
            {
              path: "kanban-produccion",
              element: <AreaProduccionKanbanProduccion />,
            },
          ],
        },
        {
          path: "manufactura",
          element: <PagesLayout />,
          children: [
            {
              path: "productos",
              element: <ManufacturaProductos />,
            },
            {
              path: "insumos",
              element: <ManufacturaInsumos />,
            },
            {
              path: "lotes",
              element: <ManufacturaLotes />,
            },
            {
              path: "stock",
              element: <ManufacturaStock />,
            },
            {
              path: "movimientos-de-stock",
              element: <ManufacturaMovimientosDeStock />,
            },
            {
              path: "insumos-por-producto",
              element: <ManufacturaInsumosPorProducto />,
            },
            {
              path: "insumos-por-orden-de-produccion",
              element: <ManufacturaInsumosPorOrdenDeProduccion />,
            },
          ],
        },
        {
          path: "agenda",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <Agenda />,
            },
          ],
        },
        {
          path: "finanzas",
          element: <PagesLayout />,
          children: [
            {
              path: "cxc",
              element: <FinanzasCxc />,
            },
            {
              path: "cxc/tabla-mensual",
              element: <FinanzasCxcTablaMensual />,
            },
            {
              path: "cxc/historico",
              element: <FinanzasCxcHistorico />,
            },
            {
              path: "cobros",
              element: <FinanzasCobros />,
            },
            {
              path: "cobros/completo",
              element: <FinanzasCobrosCompleto />,
            },
            {
              path: "cobros/generador-de-comprobante",
              element: <FinanzasCobrosGeneradorDeComprobante />,
            },
            {
              path: "cobros/historico",
              element: <FinanzasCobrosHistorico />,
            },
            {
              path: "gastos",
              element: <FinanzasGastos />,
            },
            {
              path: "gastos/completo",
              element: <FinanzasGastosCompleto />,
            },
            {
              path: "gastos/gastos-por-orden-de-produccion",
              element: <FinanzasGastosPorOrdenDeProduccion />,
            },
            {
              path: "gastos/historico",
              element: <FinanzasGastosHistorico />,
            },
            {
              path: "estado-de-resultados",
              element: <FinanzasEstadoDeResultados />,
            },
          ],
        },
        {
          path: "catalogos",
          element: <PagesLayout />,
          children: [
            {
              path: "usuarios",
              element: <CatalogosUsuarios />,
            },
            {
              path: "unidades",
              element: <CatalogosUnidades />,
            },
            {
              path: "conceptos-gastos",
              element: <CatalogosConceptosGastos />,
            },
            {
              path: "cuentas-contables",
              element: <CatalogosCuentasContables />,
            },
            {
              path: "proveedores",
              element: <CatalogosProveedores />,
            },
          ],
        },
        {
          path: "kanban-board",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <KanbanBoard />,
            },
          ],
        },
        {
          path: "kanban-individual",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <KanbanIndividual />,
            },
          ],
        },
        {
          path: "disenador-de-audifono",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <DisenadorDeAudifono />,
            },
          ],
        },
      ],
    },

    {
      //Public page: the api answers HTTP 423 when the system is locked, and login is
      //blocked too, so it must not be wrapped by the auth guard (DashboardLayout).
      path: "/sistema-bloqueado",
      element: <SystemLocked />,
    },
    {
      path: "/maintenance",
      element: <PagesLayout />,
      children: [
        {
          path: "404",
          element: <MaintenanceError />,
        },
        {
          path: "500",
          element: <MaintenanceError500 />,
        },
        {
          path: "under-construction",
          element: <MaintenanceUnderConstruction />,
        },
        {
          path: "coming-soon",
          element: <MaintenanceComingSoon />,
        },
      ],
    },
    {
      path: "/auth",
      element: <PagesLayout />,
      children: [
        {
          path: "login",
          element: <AuthLogin />,
        },
        {
          path: "register",
          element: <AuthRegister />,
        },
        {
          path: "forgot-password",
          element: <AuthForgotPassword />,
        },
        {
          path: "reset-password",
          element: <AuthResetPassword />,
        },
        {
          path: "reset-password-confirmation",
          element: <AuthResetPasswordResponse />,
        },
        {
          path: "check-mail",
          element: <AuthCheckMail />,
        },
        {
          path: "code-verification",
          element: <AuthCodeVerification />,
        },
      ],
    },
    {
      path: "/",
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: "contact-us",
          element: <MaintenanceComingSoon />,
        },
      ],
    },
    {
      path: "*",
      element: <MaintenanceError />,
    },
  ],
};

export default MainRoutes;
